import './scrollable.scss';
import React  from 'react';
import PropTypes from 'prop-types';
import utils from '../../utils/Utils';

function Scrollable(props) {
  return (
    <div style={{ height: props.height, width: props.width }}
         className={ utils.getToggleFunctionsFromMetadata().transition ? `transition-active scroller-container invisible-scrollbar ${props.className}` : `scroller-container invisible-scrollbar ${props.className}` }>
      { props.children }
    </div>
  )
}

Scrollable.propTypes = {
  className: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string
};

Scrollable.defaultProps = {
  className: '',
  height: '100%',
  width: '100%'
};

export default Scrollable;



// WEBPACK FOOTER //
// ./src/components/Scrollable/index.jsx